// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2Uv-d","label":"Radio_label__TpQOJ","checkMark":"Radio_checkMark__2TyXS","disabled":"Radio_disabled__yiOAt"};